import { Component } from "react";

import Button from "@material-ui/core/Button";

export default class FinancingTableButtons extends Component {
  closeFinancing = () => {
    let selected = this.props.getSelected();
    this.repeatforAll(selected, this.props.closeFinancing);
  };

  openFinancing = () => {
    let selected = this.props.getSelected();
    this.repeatforAll(selected, this.props.openFinancing);
  };

  unPublishFinancing = () => {
    let selected = this.props.getSelected();
    this.repeatforAll(selected, this.props.unPublishFinancing);
  };

  publishFinancing = () => {
    let selected = this.props.getSelected();
    this.repeatforAll(selected, this.props.publishFinancing);
  };

  repeatforAll = (list, func) => {
    if (list.length > 0) {
      setTimeout(() => {
        let object = list.pop();
        func(object.IntId);

        this.repeatforAll(list, func);
      }, 100);
    }
  };

  render() {
    let style = { marginRight: "10px" };
    return (
      <div>
        <Button
          variant="contained"
          color="primary"
          onClick={this.publishFinancing}
          style={style}
        >
          Publish Selected
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={this.unPublishFinancing}
          style={style}
        >
          Unpublish Selected
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={this.closeFinancing}
          style={style}
        >
          Close Selected
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={this.openFinancing}
          style={style}
        >
          Open Selected
        </Button>
      </div>
    );
  }
}
